import { GET_ALL_MUSICAS_EM_ESPERA, GET_MUSICA_EM_ESPERA_ESPECIFICA } from './mutation-types'

export default {
  [GET_ALL_MUSICAS_EM_ESPERA]: (state, musicasEmEspera) => {
    state.musicasEmEspera = musicasEmEspera
  },
  [GET_MUSICA_EM_ESPERA_ESPECIFICA]: (state, musicaEmEspera) => {
    state.musicaEmEspera = musicaEmEspera
  },
}
